module.exports = __webpack_public_path__ + "static/media/1.b1c79937.jpg";